(() => {
  const NOTE_ID = "extra-guest-note";

  function injectNote() {
    const title = document.getElementById("shopstr-booking-box-title");
    if (!title) return;

    // prevent duplicates
    if (document.getElementById(NOTE_ID)) return;

    const note = document.createElement("div");
    note.id = NOTE_ID;
    note.textContent =
      "Base rate covers 8 guests; up to allowed with $25 per extra guest.";

    note.style.fontSize = "1.25rem";
    note.style.fontWeight = "400";
    note.style.color = "rgb(107, 114, 128)";
    note.style.marginTop = "6px";

    title.insertAdjacentElement("afterend", note);
  }

  // listen for the modal event
  window.addEventListener("SHOPSTR_BOOKING_CARD_FROM_PREFIX_MOUNTED", () => {
    // slight delay to ensure DOM is mounted
    setTimeout(injectNote, 0);
  });
})();
